document.addEventListener('DOMContentLoaded', function () {

  var blogCardEl = document.querySelector('.index-blog-card-swiper');
  if (blogCardEl && typeof Swiper !== 'undefined') {
    new Swiper('.index-blog-card-swiper', {
      slidesPerView: 1.25,
      spaceBetween: 15,
      loop: true,
      pagination: { el: '.swiper-pagination', clickable: true },
      simulateTouch: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        10:   { slidesPerView: 1.25 },
        768:  { slidesPerView: 2 },
        992:  { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }

  var meetOurSlider = document.querySelector('.cons_meet_our_slider > .group-block-content');
  if (meetOurSlider && typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
    (function ($) {
      var $thumbSliderBG = $('<div class="thumb-slider-bg"></div>');
      var $thumbSlider   = $('<div class="thumb-slider"></div>');
      $thumbSliderBG.append($thumbSlider);
      $('.cons_meet_our_slider > .group-block-content').after($thumbSliderBG);

      $('.cons_meet_our_slider > .group-block-content .cons_meet_our_slide_img_main').each(function () {
        var src = $(this).find('img').first().attr('src');
        if (src) {
          $thumbSlider.append('<div><span><img src="' + src + '" /></span></div>');
        }
      });

      $('.cons_meet_our_slider > .group-block-content').slick({
        slidesToShow:   1,
        slidesToScroll: 1,
        arrows:         true,
        fade:           true,
        asNavFor:       '.thumb-slider',
        responsive: [{
          breakpoint: 749,
          settings: {
            slidesToShow:   1,
            slidesToScroll: 1,
            infinite:       true,
            dots:           false,
            fade:           false,
            centerMode:     false
          }
        }]
      });

      $('.thumb-slider').slick({
        slidesToShow:   3,
        slidesToScroll: 1,
        asNavFor:       '.cons_meet_our_slider > .group-block-content',
        focusOnSelect:  true,
        centerMode:     false,
        dots:           false,
        arrows:         false
      });
    })(jQuery);
  }

  var menuLinks = document.querySelectorAll('.menu-list__list-item a');
  var currentPath = window.location.pathname;
  menuLinks.forEach(function (link) {
    if (link.getAttribute('href') === currentPath) {
      link.parentElement.classList.add('highlight_menu');
    }
  });

  document.querySelectorAll('.custom-filter').forEach(function (button) {
    button.addEventListener('click', function () {
      var activeEl = document.querySelector('.icon-checkmark-active');
      sessionStorage.setItem('scrollTo', activeEl ? 'active' : String(window.scrollY));
    });
  });

  var scrollTo = sessionStorage.getItem('scrollTo');
  if (scrollTo === 'active') {
    var activeEl = document.querySelector('.icon-checkmark-active');
    if (activeEl) activeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else if (scrollTo) {
    window.scrollTo({ top: parseInt(scrollTo, 10), behavior: 'smooth' });
  }
  sessionStorage.removeItem('scrollTo');

  var benefitItems = document.querySelectorAll('.benefit-item');
  benefitItems.forEach(function (item) {
    item.addEventListener('click', function () {
      benefitItems.forEach(function (i) {
        if (i !== item) i.classList.remove('active');
      });
      item.classList.toggle('active');
    });
  });

});

/* ──────────────────────────────────────────────────────────────────────────
   Quick-add / PDP ADD button price keeper.

   The custom ".add-to-cart-price" inside the ADD button is server-rendered for
   the default variant only. When the variant changes (e.g. Size + Pack), the
   resolved variant's price must be re-applied — and the Loop subscription widget
   re-renders the button ~500ms later, which REMOVES the price span entirely.

   We listen for the theme's "variant:update" event (fires regardless of DOM
   quirks), read the resolved variant's price (server-formatted from the fetched
   section, with a cents fallback), and (re)create + fill the price span on the
   ADD button — re-applying a few times to outlast Loop's async re-render.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  function formatMoneyFallback(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function applyAddButtonPrice(scope, priceStr, compareStr) {
    if (!scope) return;

    var candidates = scope.querySelectorAll("button[name='add'], button[type='submit']");
    var btn = null;
    for (var i = 0; i < candidates.length; i++) {
      if (/add/i.test(candidates[i].textContent || '')) {
        btn = candidates[i];
        break;
      }
    }
    if (!btn) btn = scope.querySelector('button');
    if (!btn) return;

    var priceEl = btn.querySelector('.add-to-cart-price');
    if (!priceEl) {
      priceEl = document.createElement('span');
      priceEl.className = 'add-to-cart-price';
      btn.appendChild(priceEl);
    }

    priceEl.innerHTML =
      ' ' + priceStr + ' ' +
      (compareStr ? '<span class="compare_at_price"><s>' + compareStr + '</s></span>' : '');
  }

  document.addEventListener('variant:update', function (event) {
    var detail = event.detail || {};
    var html = detail.data && detail.data.html;

    var priceStr = '';
    var compareStr = '';

    // Preferred: the resolved variant's server-formatted price from the fetched section.
    if (html && html.querySelector) {
      var priceNode = html.querySelector('product-price .price');
      var compareNode = html.querySelector('product-price .compare-at-price');
      if (priceNode) priceStr = (priceNode.textContent || '').trim();
      if (compareNode) compareStr = (compareNode.textContent || '').trim();
    }

    // Fallback: format from the variant resource (price is in cents).
    var resource = detail.resource;
    if (!priceStr && resource && typeof resource.price === 'number') {
      priceStr = formatMoneyFallback(resource.price);
      if (resource.compare_at_price && resource.compare_at_price > resource.price) {
        compareStr = formatMoneyFallback(resource.compare_at_price);
      }
    }

    if (!priceStr) return;

    var picker = event.target;
    var scope =
      (picker && picker.closest && picker.closest('dialog, .shopify-section, product-card')) ||
      document.querySelector('dialog[open], .quick-add-modal') ||
      document;

    // Apply now, then again to outlast Loop's ~500ms re-render (which removes the span).
    applyAddButtonPrice(scope, priceStr, compareStr);
    [120, 350, 650, 1100, 1700].forEach(function (ms) {
      setTimeout(function () {
        applyAddButtonPrice(scope, priceStr, compareStr);
      }, ms);
    });
  });
})();
